/** IconButton — square bordered button used for copy/rotate/close affordances. */
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { colors, radii } from '../theme';

type Props = { onPress?: () => void; size?: number; children: React.ReactNode; title?: string; dashed?: boolean };

export default function IconButton({ onPress, size = 34, children, title, dashed }: Props) {
  return (
    <Pressable
      onPress={onPress}
      title={title}
      style={[styles.btn, { width: size, height: size, borderStyle: dashed ? 'dashed' : 'solid' }]}
    >
      {children}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  btn: {
    flexShrink: 0,
    borderRadius: radii.r2,
    borderWidth: 1,
    borderColor: colors.lineStrong,
    backgroundColor: colors.card,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  } as any,
});
